import React from "react";
import ReactDOM from "react-dom";
import styles from "./style.module.scss";

interface GalleryModalWrapperProps {
  children: React.ReactNode;
}

export default class GalleryModalWrapper extends React.Component<GalleryModalWrapperProps> {
  private el: HTMLDivElement;

  constructor(props: GalleryModalWrapperProps) {
    super(props);
    this.el = document.createElement("div");
    this.el.className = styles.galleryModalBackdrop;
  }

  componentDidMount() {
    document.body.appendChild(this.el);
    document.body.style.overflow = "hidden";
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
    document.body.style.overflow = "auto";
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}
